@if (getShouldRender()) {
  <div class="toggle-group pb-0">
    <mat-slide-toggle
      #devModeToggle
      [checked]="getCurrentState()"
      (change)="onToggleChange(devModeToggle)"
    >
      Prod Mode
    </mat-slide-toggle>
  </div>
}
